import { enLocale } from './locales_en'

interface Ti18ParamOptions {
  defaultValue: string
}

const i18Translation = (key: string | undefined): string | undefined => enLocale[key ?? '']

export const i18WithDefault = (key: string | undefined, options?: Ti18ParamOptions) =>
  i18Translation(key) || options?.defaultValue || ''

export const i18WithParams = (key: string | undefined, params: { [key: string]: string } = {}) => {
  return Object.entries(params).reduce(
    (res, [paramKey, paramValue]) => res.replaceAll(`{{${paramKey}}}`, paramValue),
    i18WithDefault(key)
  )
}

export default i18Translation
